var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-title",attrs:{"data-external":"hero-title"}},[_c('BaseHeading',{staticClass:"page-title__heading",attrs:{"level":1,"title":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }